<template>
  <el-select class="select-corp" size="mini" @change="changeCode" v-model="id" placeholder="选择销方单位">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
// <invoice-type v-model:code="temp.fplx"></invoice-type>
import { getCorpList } from "@/api/ea";
export default {
  name: 'corpComponent',
  props: {
    name: '',
  },
  data() {
    return {
      id: "",
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
      },
      list: [],
    }
  },
  created () {
    this.getList()
  },
  methods: {
    changeCode(){
      let infos = this.list.filter(v=>{return this.id == v.id})
      if(infos.length == 1){
        this.$emit('update:id', this.id)
        this.$emit('update:name', infos[0].name)
        this.$emit('success', infos[0])
      }
    },
    getList(){
      getCorpList(this.listQuery).then(res=>{
        if(res.data.data.list){
          this.list = res.data.data.list
          this.list.map(v=>{
            if(v.name == this.name){
              this.id = v.id
            }
          })
          //选择默认的 
          if(!this.id && res.data.data.list){
            this.id = res.data.data.list[0].id
            this.changeCode()
          }
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.select-corp{
  width: 100%;
}
</style>
